import { ConfigurableText, NavigationPage } from '@/app/components'
import { getPermissionsEditUrl } from '../verify-permissions/utils'
import { ButtonContainer } from '../../ava/BrandedPage'
import carImage from './car.png'
import { Button, Icon } from '@/components'

export default function NoVehicleInformation() {
  // Set up the back URL to be our Tesla Fleet Auth Redirect path
  const backUrl = `${window.location.origin}/tesla-fleet-auth-redirect${window.location.search}`
  const editUrl = getPermissionsEditUrl(backUrl)

  return (
    <NavigationPage
      id="no-vehicle-information"
      progressBar={{
        completedSteps: 1,
        totalSteps: 2,
      }}
      navigationOptions={['back', 'close']}
      onCloseClick={() => {}}
    >
      <NavigationPage.SingleCardContent>
        <div className="flex flex-row items-start justify-start gap-3">
          <div className="w-5 h-5 mt-1">
            <Icon name="AlertCircleFilled" className="text-red-500 " />
          </div>
          <div className="flex flex-col gap-3">
            <ConfigurableText variant="h2">
              Uh oh, we have not detected any vehicles.
            </ConfigurableText>
            <ConfigurableText variant="body4">
              We didn’t see any vehicles in your Tesla account. You need to
              select <span className="font-bold">Vehicle Information</span> from
              the Tesla permissions page.
            </ConfigurableText>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <img src={carImage} alt="Car" className="w-full h-full -mt-2" />
        </div>
        <ButtonContainer>
          <Button
            id="update-permissions-button-no-vehicle-information"
            variant="primary"
            onClick={() => {
              window.location.href = editUrl
            }}
          >
            Update Permissions
          </Button>
        </ButtonContainer>
      </NavigationPage.SingleCardContent>
    </NavigationPage>
  )
}
